module.exports = __webpack_public_path__ + "media/images/stripe/blue-on-light-19f3bfdafb39de4b2078b436c46a7428.png";